/*
  The property data should be an Array of Array<String> => 2D array
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import FullPageLayout from '../../../components/FullPageLayout';
import { CloseButton } from 'dabbl-react-components';

// Event Listener
import escKeyListener from '../../../eventListeners/escListener';

class LegalDocumentLayout extends Component {

  static propTypes = {

    // Document - Required
    docTitle: PropTypes.string.isRequired,
    docData: PropTypes.array.isRequired,
    // mixpanelPageName: PropTypes.string.isRequired,
    // Document - Optional
    numbered: PropTypes.bool,

    // Redux Actions
    setLoading: PropTypes.func.isRequired,
  }

  static defaultProps = {
    numbered: false,
  }

  componentDidMount() {
    const {
      // Redux
      setLoading,
      history
    } = this.props;

    setLoading(false);
    window.scrollTo(0,0); // scroll to top of page

    this.removeEscEventListener = escKeyListener(() => history.goBack());
  }

  componentWillUnmount() {
    this.removeEscEventListener();
  }

  render() {
    const {
      docTitle,
      docData,
      numbered,
      history
    } = this.props;

    return (
      <div>
        <FullPageLayout>
          <div className="LegalDocumentLayout">

            <Container>
              <Row>
                <Col xs={12}>
                  <CloseButton onClick={() => history.goBack()} />
                </Col>
                <Col xs={12} className="LegalDocumentLayout_title">
                  {docTitle}
                </Col>
              </Row>
            </Container>

            {docData.map((row, rkey) => (
              <Container className="LegalDocumentLayout_block" key={rkey}>
                <Row>
                  {row.header && (
                    <Col xs={12}>
                      {(numbered) ? <h4>{rkey+1}. {row.header}</h4> : <h4>{row.header}</h4>}
                    </Col>
                  )}

                  <Container>
                    {row.body && (row.body.map((paragraph, pkey) => (
                      <Col xs={12} key={pkey}>
                        <p dangerouslySetInnerHTML={{__html: paragraph}}></p>
                      </Col>
                    )))}
                  </Container>
                </Row>
              </Container>
            ))}

          </div>
        </FullPageLayout>
      </div>
    );
  }
}

export default LegalDocumentLayout;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/LegalDocumentLayout/LegalDocumentLayout.js